export default {
    Employee: 'employee',
    Tenant: 'tenant',
}
